<template>
    <div 
    class="tw-flex tw-justify-center tw-items-center tw-overflow-hidden tw-border-2 tw-border-white tw-bg-gray-300 tw-box-content" 
    :class="{ 'tw-rounded-full':circle }"
    :style="circle ? { width: size, height: size } : imageDimensions">
        <img 
        v-if="hasPicture" 
        :src="location" 
        alt="picture" 
        class="tw-object-contain" 
        :style="imageDimensions"
        @load="test"
        ref="image">

        <i v-else :class="icon" :style="{fontSize : svgSize}"></i>
    </div>
</template>

<script>
export default {
    name: "Portrait",

    props: {
        size: {
            type: String,
            default: "40px"
        },
        location: {
            type: String,
            default: ""
        },
        circle: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            default: 'fa fa-user'
        },
    },

    data() {
        return {
            imageDimensions: {
                height: this.size,
                width: this.size
            }
        }
    },

    computed: {
        hasPicture() {
            return this.location ? true : false;
        },
        svgSize() {
            return Math.round(this.size.replace("px", '') / 3.33) + 'px';
        }
    },

    watch: {
        location(value) {
            if(!value) {
                // If the image is ever removed, reset the image dimensions
                this.imageDimensions = {
                    height: this.size,
                    width: this.size
                };
            }
        }
    },

    // mounted() {
    //     
    // },

    methods: {
        test(event) {
            // The simplest way to resize the component is to listen for any image loads, which guarantees the natural width and height properties are available
            let image = event.target;
            let isLandscape = image.naturalWidth > image.naturalHeight;

            this.imageDimensions = {
                width: isLandscape ? this.size : null,
                height: isLandscape ? null : this.size
            }
        }
    }
}
</script>

<style>

</style>